<script>
export default {
    name: 'IconChecklist'
}
</script>
<template>
    <svg
        class="base-icon icon-checklist"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 8v48H12V8h40zM26 41h-6v6h6v-6zm20 1H32v4h14v-4zM27 27.5l-5 5-2-2-2 2 4 4 7-7-2-2zM46 30H32v4h14v-4zM27 16l-5 5-2-2-2 2 4 4 7-7-2-2zm19 2.5H32v4h14v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
